import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { EditOperation } from '../../common/core/editOperation.js';
import { Position } from '../../common/core/position.js';
import { Range } from '../../common/core/range.js';
import { Selection } from '../../common/core/selection.js';
import { LanguageConfigurationRegistry } from '../../common/modes/languageConfigurationRegistry.js';
export var BlockCommentCommand = /*#__PURE__*/function () {
  function BlockCommentCommand(selection, insertSpace) {
    _classCallCheck(this, BlockCommentCommand);

    this._selection = selection;
    this._insertSpace = insertSpace;
    this._usedEndToken = null;
  }

  _createClass(BlockCommentCommand, [{
    key: "_createOperationsForBlockComment",
    value: function _createOperationsForBlockComment(selection, startToken, endToken, insertSpace, model, builder) {
      var startLineNumber = selection.startLineNumber;
      var startColumn = selection.startColumn;
      var endLineNumber = selection.endLineNumber;
      var endColumn = selection.endColumn;
      var startLineText = model.getLineContent(startLineNumber);
      var endLineText = model.getLineContent(endLineNumber);
      var startTokenIndex = startLineText.lastIndexOf(startToken, startColumn - 1 + startToken.length);
      var endTokenIndex = endLineText.indexOf(endToken, endColumn - 1 - endToken.length);

      if (startTokenIndex !== -1 && endTokenIndex !== -1) {
        if (startLineNumber === endLineNumber) {
          var lineBetweenTokens = startLineText.substring(startTokenIndex + startToken.length, endTokenIndex);

          if (lineBetweenTokens.indexOf(endToken) >= 0) {
            // force to add a block comment
            startTokenIndex = -1;
            endTokenIndex = -1;
          }
        } else {
          var startLineAfterStartToken = startLineText.substring(startTokenIndex + startToken.length);
          var endLineBeforeEndToken = endLineText.substring(0, endTokenIndex);

          if (startLineAfterStartToken.indexOf(endToken) >= 0 || endLineBeforeEndToken.indexOf(endToken) >= 0) {
            // force to add a block comment
            startTokenIndex = -1;
            endTokenIndex = -1;
          }
        }
      }

      var ops;

      if (startTokenIndex !== -1 && endTokenIndex !== -1) {
        // Consider spaces as part of the comment tokens
        if (insertSpace && startTokenIndex + startToken.length < startLineText.length && startLineText.charCodeAt(startTokenIndex + startToken.length) === 32
        /* Space */
        ) {
          // Pretend the start token contains a trailing space
          startToken = startToken + ' ';
        }

        if (insertSpace && endTokenIndex > 0 && endLineText.charCodeAt(endTokenIndex - 1) === 32
        /* Space */
        ) {
          // Pretend the end token contains a leading space
          endToken = ' ' + endToken;
          endTokenIndex -= 1;
        }

        ops = BlockCommentCommand._createRemoveBlockCommentOperations(new Range(startLineNumber, startTokenIndex + startToken.length + 1, endLineNumber, endTokenIndex + 1), startToken, endToken);
      } else {
        ops = BlockCommentCommand._createAddBlockCommentOperations(selection, startToken, endToken, this._insertSpace);
        this._usedEndToken = ops.length === 1 ? endToken : null;
      }

      var _iterator = _createForOfIteratorHelper(ops),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var op = _step.value;
          builder.addTrackedEditOperation(op.range, op.text);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "getEditOperations",
    value: function getEditOperations(model, builder) {
      var startLineNumber = this._selection.startLineNumber;
      var startColumn = this._selection.startColumn;
      model.tokenizeIfCheap(startLineNumber);
      var languageId = model.getLanguageIdAtPosition(startLineNumber, startColumn);
      var config = LanguageConfigurationRegistry.getComments(languageId);

      if (!config || !config.blockCommentStartToken || !config.blockCommentEndToken) {
        // Mode does not support block comments
        return;
      }

      this._createOperationsForBlockComment(this._selection, config.blockCommentStartToken, config.blockCommentEndToken, this._insertSpace, model, builder);
    }
  }, {
    key: "computeCursorState",
    value: function computeCursorState(model, helper) {
      var inverseEditOperations = helper.getInverseEditOperations();

      if (inverseEditOperations.length === 2) {
        var startTokenEditOperation = inverseEditOperations[0];
        var endTokenEditOperation = inverseEditOperations[1];
        return new Selection(startTokenEditOperation.range.endLineNumber, startTokenEditOperation.range.endColumn, endTokenEditOperation.range.startLineNumber, endTokenEditOperation.range.startColumn);
      } else {
        var srcRange = inverseEditOperations[0].range;
        var deltaColumn = this._usedEndToken ? -this._usedEndToken.length - 1 : 0; // minus 1 space before endToken

        return new Selection(srcRange.endLineNumber, srcRange.endColumn + deltaColumn, srcRange.endLineNumber, srcRange.endColumn + deltaColumn);
      }
    }
  }], [{
    key: "_haystackHasNeedleAtOffset",
    value: function _haystackHasNeedleAtOffset(haystack, needle, offset) {
      if (offset < 0) {
        return false;
      }

      var needleLength = needle.length;
      var haystackLength = haystack.length;

      if (offset + needleLength > haystackLength) {
        return false;
      }

      for (var i = 0; i < needleLength; i++) {
        var codeA = haystack.charCodeAt(offset + i);
        var codeB = needle.charCodeAt(i);

        if (codeA === codeB) {
          continue;
        }

        if (codeA >= 65
        /* A */
        && codeA <= 90
        /* Z */
        && codeA + 32 === codeB) {
          // codeA is upper-case variant of codeB
          continue;
        }

        if (codeB >= 65
        /* A */
        && codeB <= 90
        /* Z */
        && codeB + 32 === codeA) {
          // codeB is upper-case variant of codeA
          continue;
        }

        return false;
      }

      return true;
    }
  }, {
    key: "_createRemoveBlockCommentOperations",
    value: function _createRemoveBlockCommentOperations(r, startToken, endToken) {
      var res = [];

      if (!Range.isEmpty(r)) {
        // Remove block comment start
        res.push(EditOperation.delete(new Range(r.startLineNumber, r.startColumn - startToken.length, r.startLineNumber, r.startColumn))); // Remove block comment end

        res.push(EditOperation.delete(new Range(r.endLineNumber, r.endColumn, r.endLineNumber, r.endColumn + endToken.length)));
      } else {
        // Remove both continuously
        res.push(EditOperation.delete(new Range(r.startLineNumber, r.startColumn - startToken.length, r.endLineNumber, r.endColumn + endToken.length)));
      }

      return res;
    }
  }, {
    key: "_createAddBlockCommentOperations",
    value: function _createAddBlockCommentOperations(r, startToken, endToken, insertSpace) {
      var res = [];

      if (!Range.isEmpty(r)) {
        // Insert block comment start
        res.push(EditOperation.insert(new Position(r.startLineNumber, r.startColumn), startToken + (insertSpace ? ' ' : ''))); // Insert block comment end

        res.push(EditOperation.insert(new Position(r.endLineNumber, r.endColumn), (insertSpace ? ' ' : '') + endToken));
      } else {
        // Insert both continuously
        res.push(EditOperation.replace(new Range(r.startLineNumber, r.startColumn, r.endLineNumber, r.endColumn), startToken + '  ' + endToken));
      }

      return res;
    }
  }]);

  return BlockCommentCommand;
}();